import fetch from '@/utils/fetch';

// 获取资金账户余额
export function getCashAccount() {
  return fetch({
    url: '/shop/v1/susers/account',
    method: 'get'
  })
}

export function requestPay(money) {
  return fetch({
    url: '/pay/weixin/',
    method: 'post',
    data: {
      money: money,
      trade_type: "NATIVE",
      service_type: "guarantee"
    }
  })
}

export function getGuarantees(recharge_id) {
  return fetch({
    url: `/guarantees/${recharge_id}`,
    method: 'get'
  })
}

// 获取账单信息
export function getBillList(data = {}) {
  return fetch({
    url: '/shop/v1/susers/bill',
    data,
    method: 'post'
  })
}

// 发起体现申请
export function withdraw(data) {
  return fetch({
    url: '/shop/v1/susers/withdraw',
    data,
    method: 'post'
  })
}

// 重置密码
export function resetPassword() {
  return fetch({
    url: '/shop/v1/susers/reset',
    method: 'post'
  })
}

// 获取收支信息
export function getOrderRecords(params) {
  return fetch({
    url: '/shop/v1/order_records',
    method: 'get',
    params
  })
}

// 获取银行列表
export function getBankList() {
  return fetch({
    url: 'https://fulishe-static.oss-cn-zhangjiakou.aliyuncs.com/static/json/bank.json',
    method: 'get'
  })
}